import { EAsidePanelProperty, EAsidePanelType } from '../../../../../../asidePanel/components/AsidePanel/types';
import { CARD_PROPERTIES, CARD_TEMPLATE_PROPERTIES } from '../../../../../constants';
import {
    EKanbanCardProperty,
    IApplicationState,
    TBoardId,
    TKanbanCardProperty
} from '../../../../../../../../../types/types';
import {
    getBoardCardDefaultProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardCardDefaultProperties';
import {
    getBoardCardRequiredProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardCardRequiredProperties';
import { ICardPropertyElement } from '../../../components/CardProperties/types';
import {
    getBoardCustomProperties
} from '../../../../CardCustomProperties/hocs/CustomPropertiesHOC/selectors/getBoardCustomProperties';
import { getBoardCardProperties } from '../../../../../../../../../store/model/board/selectors/getBoardCardProperties';
import { createDeepEqualSelector } from '../../../../../../../helpers/memoizeHelper';
import { ICardProperty } from '../../../../../../../../../types/rest/IRestBoardMeta';
import {
    getBoardDefaultCardPreviewHiddenProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardDefaultCardPreviewHiddenProperties';
import { getPreviewKey } from '../helpers/getPreviewKey';
import {
    ICustomPropertiesElement
} from '../../../../../../../base/components/CustomProperties/components/CustomProperty/types';
import {
    getBoardDefaultCardPreviewCustomProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardDefaultCardPreviewCustomProperties';

type TgetCardPropertiesForSettings = (
    state: IApplicationState,
    boardId: TBoardId,
    type: EAsidePanelType,
) => ICardPropertyElement[];

const getCardPropertiesForSettingsSelector = (
    boardProperties: ICardProperty[],
    boardDefaultProperties: Set<EAsidePanelProperty>,
    boardRequiredProperties: Set<EAsidePanelProperty>,
    boardPreviewProperties: TKanbanCardProperty[],
    boardCustomPreviewProperties: TKanbanCardProperty[],
    boardCustomProperties: ICustomPropertiesElement[],
    type: EAsidePanelType,
): ICardPropertyElement[] => {
    const isTemplate = type === EAsidePanelType.CARD_TEMPLATE;
    const properties = isTemplate ? CARD_TEMPLATE_PROPERTIES : CARD_PROPERTIES;

    const cardProperties: ICardPropertyElement[] = [];
    properties.forEach(property => {
        if (property.key === EAsidePanelProperty.CARD_CUSTOM) {
            const customCardProperty = boardProperties.find(({ property }) => property === EAsidePanelProperty.CARD_CUSTOM);
            const customCardDefaultProperty = customCardProperty && customCardProperty.options &&
                customCardProperty.options.filter(({ isDefault }) => isDefault)
                    .map(item => item.option);
            const customCardRequiredProperty = customCardDefaultProperty && customCardProperty.options &&
                customCardProperty.options.filter(({ isRequired }) => isRequired)
                    .map(item => item.option);
            boardCustomProperties.forEach(customProperty => {
                cardProperties.push({
                    ...property,
                    option: customProperty.id,
                    name: customProperty.name,
                    isDefault: customCardDefaultProperty && customCardDefaultProperty.includes(customProperty.id),
                    isRequired: customCardRequiredProperty && customCardRequiredProperty.includes(customProperty.id),
                    isViewOnPreview: boardCustomPreviewProperties && boardCustomPreviewProperties.includes(EKanbanCardProperty.CUSTOM_PROPERTIES + customProperty.id),
                    isPreview: true,
                });
            });
        } else {
            cardProperties.push({
                ...property,
                isDefault: boardDefaultProperties.has(property.key as EAsidePanelProperty),
                isRequired: boardRequiredProperties.has(property.key as EAsidePanelProperty),
                isViewOnPreview: (property.isPreview || property.isPreviewOnly) && !boardPreviewProperties.includes(getPreviewKey(property.key)),
            });
        }
    });

    return cardProperties;
}

export const getCardPropertiesForSettingsCreateSelector = (
): TgetCardPropertiesForSettings => createDeepEqualSelector(
    getBoardCardProperties,
    getBoardCardDefaultProperties,
    getBoardCardRequiredProperties,
    getBoardDefaultCardPreviewHiddenProperties,
    getBoardDefaultCardPreviewCustomProperties,
    getBoardCustomProperties,
    (state: IApplicationState, type: EAsidePanelType) => type,
    getCardPropertiesForSettingsSelector,
);
